import i18next from 'i18next';
import * as Yup from 'yup';

export const SCI_CUSTOMER_ALTERNATIVES_MAX_TIMEOUT = 60;
export const SCI_CUSTOMER_ALTERNATIVES_MAX_ATTEMPTS = 10;
export const MAX_PARALLEL_CUSTOMER_ORDERS_LIMIT = 10;

export const SCI_CUSTOMER_ALTERNATIVES_VALIDATION_SCHEMA = Yup.object().shape({
  alternativeAmountEnabled: Yup.boolean().required(
    i18next.t('errors.required'),
  ),
  alternativeTradeMethodEnabled: Yup.boolean().required(
    i18next.t('errors.required'),
  ),
  timeout: Yup.number()
    .nullable()
    .min(1, i18next.t('errors.natural_number'))
    .max(
      SCI_CUSTOMER_ALTERNATIVES_MAX_TIMEOUT,
      `${i18next.t('errors.max')} ${SCI_CUSTOMER_ALTERNATIVES_MAX_TIMEOUT}`,
    )
    .when(['alternativeAmountEnabled', 'alternativeTradeMethodEnabled'], {
      is: (
        alternativeAmountEnabled: boolean,
        alternativeTradeMethodEnabled: boolean,
      ) => alternativeAmountEnabled || alternativeTradeMethodEnabled,
      then: (schema) => schema.required(i18next.t('errors.required')),
      otherwise: (schema) => schema.optional().nullable(),
    }),
  maxAttempts: Yup.number()
    .nullable()
    .min(1, i18next.t('errors.natural_number'))
    .max(
      SCI_CUSTOMER_ALTERNATIVES_MAX_ATTEMPTS,
      `${i18next.t('errors.max')} ${SCI_CUSTOMER_ALTERNATIVES_MAX_ATTEMPTS}`,
    )
    .when(['alternativeAmountEnabled', 'alternativeTradeMethodEnabled'], {
      is: (
        alternativeAmountEnabled: boolean,
        alternativeTradeMethodEnabled: boolean,
      ) => alternativeAmountEnabled || alternativeTradeMethodEnabled,
      then: (schema) => schema.required(i18next.t('errors.required')),
      otherwise: (schema) => schema.optional().nullable(),
    }),
});
